export const SBA_MORE_INFORMATION_URL =
  "https://c9g9o.share-na2.hsforms.com/2RJXKgMatRUGkpJXzBC2f3w";

export type OnboardWidgetCta = {
  label: "Apply Now" | "More Information";
  href: string | null;
};

export function getOnboardWidgetCta(
  referralTag?: string,
): OnboardWidgetCta {
  const normalizedReferralTag = referralTag
    ?.trim()
    .replace(/^["'“”‘’]+|["'“”‘’]+$/g, "")
    .trim()
    .toLowerCase();

  if (normalizedReferralTag === "sba") {
    return {
      label: "More Information",
      href: SBA_MORE_INFORMATION_URL,
    };
  }

  return {
    label: "Apply Now",
    href: null,
  };
}
